import React from "react";

import { AUTOPILOT_COLORS } from "../autopilot/styles";

// Aviso de "selecione um embarcador" por token (PO1-2724): acompanha tema
// claro/escuro em vez das cores cravadas de antes.
// PO1-3646 (épico PO1-3359): variante `info` para avisos que não são bloqueio
// (boas-vindas da Rede Everlog no MeuFrete); `warning` continua o padrão.
const containerStyle = {
  border: `1px solid ${AUTOPILOT_COLORS.statusWarningBorder}`,
  background: AUTOPILOT_COLORS.statusWarningBg,
  color: AUTOPILOT_COLORS.text,
  borderRadius: 12,
  padding: "0.95rem 1rem",
  marginBottom: "1rem",
};

const VARIANTES = {
  warning: containerStyle,
  info: {
    ...containerStyle,
    border: `1px solid ${AUTOPILOT_COLORS.statusInfo}`,
    background: "var(--theme-accent-glow)",
  },
};

const titleStyle = {
  fontSize: "0.92rem",
  fontWeight: 600,
  marginBottom: "0.35rem",
  color: AUTOPILOT_COLORS.title,
};

const textStyle = {
  margin: 0,
  fontSize: "0.86rem",
  lineHeight: 1.5,
};

export default function SpecificEmpresaRequiredNotice({
  title = "Seleção necessária",
  message = "Selecione um embarcador específico para usar esta tela.",
  variant = "warning",
  children,
}) {
  return (
    <div style={VARIANTES[variant] || containerStyle} role={variant === "info" ? "status" : undefined}>
      <div style={titleStyle}>{title}</div>
      <p style={textStyle}>{message}</p>
      {children}
    </div>
  );
}
